<template>
  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1"
       id="Capa_1"
       x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve"
       width="512" height="512">
              <g>
                <g>
		              <path
                      style="fill:none;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                      d="&#10;&#9;&#9;&#9;M417.103,419.12V20.02c0-5.534-4.486-10.02-10.02-10.02H71.051c-5.534,0-10.02,4.486-10.02,10.02v443.771&#10;&#9;&#9;&#9;c0,20.498,16.152,37.767,36.645,38.2c10.675,0.226,20.347-4.014,27.308-10.963c6.773-6.784,10.972-16.143,10.972-26.496V431.35&#10;&#9;&#9;&#9;c0-5.534,4.486-10.02,10.02-10.02h294.973c5.534,0,10.02,4.486,10.02,10.02v31.978c0,21.358-17.314,38.672-38.672,38.672H98.488"/>
	              </g>
                <g>
		              <path
                      style="fill:none;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                      d="&#10;&#9;&#9;&#9;M179.44,86.96c0,0-15.29-12.653-33.81-7.074c-17.005,5.123-21.229,28.391-9.673,37.454c6.635,5.204,16.62,9.483,30.075,14.24&#10;&#9;&#9;&#9;c30.116,10.645,18.983,53.117-11.651,53.321c-11.955,0.08-17.544-0.679-28.046-7.549"/>
                  <line
                      style="fill:none;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                      x1="154.386" y1="200.399" x2="154.386" y2="184.898"/>
                  <line
                      style="fill:none;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                      x1="154.386" y1="78.351" x2="154.386" y2="63.982"/>
	              </g>
                <line style="fill:none;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                      x1="280.682" y1="124.422" x2="367.888" y2="124.422"/>
                <line style="fill:none;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                      x1="240.756" y1="164.504" x2="367.888" y2="164.504"/>
                <line style="fill:none;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                      x1="150.974" y1="255.757" x2="343.248" y2="255.757"/>
                <line style="fill:none;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                      x1="150.974" y1="305.859" x2="343.248" y2="305.859"/>
                <line style="fill:none;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                      x1="150.974" y1="355.961" x2="297.584" y2="355.961"/>
                <line style="fill:none;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
                      x1="343.248" y1="355.961" x2="343.248" y2="355.961"/>
              </g>
            </svg>
</template>
